"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTranslationsWithoutNamespaces = void 0;
/**
 * A utility type that extracts keys from each namespace in a collection of translations with namespaces.
 * It returns a union of all keys present in the namespaces.
 *
 * @typeParam T Type representing translations with namespaces.
 */ /**
 * A utility type that extracts keys from a collection of translations with namespaces.
 * It uses the `NamespaceKeys` utility type to get a union of keys from all namespaces.
 *
 * @typeParam T Type representing translations with namespaces.
 */ /**
 * Represents the result type of the `getTranslationsWithoutNamespaces` function.
 * It maps the extracted keys from translations with namespaces to corresponding string values.
 *
 * @typeParam T Type representing translations with namespaces.
 */ /**
 * Extracts translations without namespaces from a collection of translations with namespaces.
 *
 * @typeParam T  Type representing translations with namespaces.
 * @param translationsWithNamespaces The collection which consists of namespaces and its key, value definition.
 * @returns flattened keys of each namespace as object.
 */ var getTranslationsWithoutNamespaces = function(translationsWithNamespaces) {
    var translationsWithoutNamespaces = {};
    for(var namespace in translationsWithNamespaces){
        if (Object.prototype.hasOwnProperty.call(translationsWithNamespaces, namespace)) {
            var namespaceTranslations = translationsWithNamespaces[namespace];
            for(var key in namespaceTranslations){
                if (Object.prototype.hasOwnProperty.call(namespaceTranslations, key)) {
                    var value = namespaceTranslations[key];
                    if (typeof value === 'string') {
                        translationsWithoutNamespaces = _object_spread_props(_object_spread({}, translationsWithoutNamespaces), _define_property({}, key, value));
                    }
                }
            }
        }
    }
    return translationsWithoutNamespaces;
};
exports.getTranslationsWithoutNamespaces = getTranslationsWithoutNamespaces; //# sourceMappingURL=getTranslationsWithoutNamespaces.js.map
